import { render, staticRenderFns } from "./PromotionIndex.vue?vue&type=template&id=416f7728&scoped=true"
import script from "./PromotionIndex.vue?vue&type=script&lang=js"
export * from "./PromotionIndex.vue?vue&type=script&lang=js"
import style0 from "./PromotionIndex.vue?vue&type=style&index=0&id=416f7728&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f7728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('416f7728')) {
      api.createRecord('416f7728', component.options)
    } else {
      api.reload('416f7728', component.options)
    }
    module.hot.accept("./PromotionIndex.vue?vue&type=template&id=416f7728&scoped=true", function () {
      api.rerender('416f7728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/promotion/PromotionIndex.vue"
export default component.exports